import type { RouteRecordRaw } from 'vue-router'

export const adminCategoriesRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/categories',
    name: 'admin-categories',
    component: () => import('./pages/AdminCategoriesPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
